import { Tags } from '@spotify-internal/semantic-metrics';
import { Logger } from './Logger';

export enum Target {
  fetch = 300,
  appMount = 1000,
}

enum Level {
  satisfied = 'satisfied',
  tolerating = 'tolerating',
  frustrated = 'frustrated',
}

function getLevel(value: number, target: number) {
  if (value <= target) return Level.satisfied;
  else if (value <= target * 4) return Level.tolerating;
  return Level.frustrated;
}

export function logApdexMetric(
  what: string,
  value: number,
  target: number,
  tags: Tags = {},
) {
  Logger.logCount(what, {
    ...tags,
    apdex: 'true',
    apdex_level: getLevel(value, target),
    apdex_version: '1',
  });
}

function logApdex(what: string, level: Level, tags: Tags = {}) {
  Logger.logCount(what, {
    ...tags,
    apdex: 'true',
    apdex_level: level,
    apdex_version: '1',
  });
}

// exported for tests
export function _logAppMountApdex(value: number) {
  logApdex('app.mount', getLevel(value, Target.appMount));
}

export function logAppMountApdex() {
  if (!('PerformanceNavigationTiming' in window)) return;

  const [entry] = performance.getEntriesByType(
    'navigation',
  ) as PerformanceNavigationTiming[];

  const value = performance.now() - entry.responseStart;

  _logAppMountApdex(value);
}

export function logFetchApdex(what: string, value: number) {
  logApdex(what, getLevel(value, Target.fetch));
}

export function logFetchError(what: string) {
  logApdex(what, Level.frustrated, { error: 'true' });
}
